import { marketplaceType } from "@redotech/redo-model/catalog/catalog";
import {
  CatalogProductSchema_,
  CatalogVariantSchema,
} from "@redotech/redo-model/catalog/catalog-product-types";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const paginationInputSchema = z.object({
  limit: z.number().min(1).optional(),
  cursor: z.string().optional(),
});

const CatalogVariantWithInventorySchema_ = CatalogVariantSchema.and(
  z.object({ available: z.number().min(0) }),
);

export const CatalogVariantWithInventorySchema: z.ZodType<CatalogVariantWithInventory> =
  CatalogVariantWithInventorySchema_;
export interface CatalogVariantWithInventory
  extends z.infer<typeof CatalogVariantWithInventorySchema_> {}

export const CatalogProductWithInventorySchema_ = CatalogProductSchema_.extend({
  variants: z.array(CatalogVariantWithInventorySchema),
});

export const CatalogProductWithInventorySchema: z.ZodType<CatalogProductWithInventory> =
  CatalogProductWithInventorySchema_;
export interface CatalogProductWithInventory
  extends z.infer<typeof CatalogProductWithInventorySchema_> {}

export const getMarketplaceProducts = {
  name: "getMarketplaceProducts" as const,
  input: z.object({
    marketplaceType: createEnum(marketplaceType),
    pagination: paginationInputSchema.optional(),
    query: z.string().optional(),
    sortBy: createEnum(["price", "name", "created_at"]).optional(),
    sortDirection: createEnum(["asc", "desc"]).optional(),
  }),
  output: z.object({
    products: z.array(CatalogProductWithInventorySchema),
    paginationKey: z.string().nullish(),
    totalCount: z.number(),
  }),
};
